import { render, staticRenderFns } from "./DataViewerCell.vue?vue&type=template&id=024f1a4a&"
import script from "./DataViewerCell.vue?vue&type=script&lang=js&"
export * from "./DataViewerCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports